import React, { Component } from "react";
import { languages } from "../../constants/languages";
import EditBreakDialog from "../../components/schedule/EditBreakDialog";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
import LockIcon from "@material-ui/icons/Lock";

class EditBreakContainer extends Component {
  state = {
    open: false,
    name: this.props.isEvent ? "" : languages.schedule.break,
    duration: 20,
    selectedTeams: [],
    selectedTeamsValue: [],
  };

  handleSelectChange = (e, value) => {
    let selectedValue = [];
    let selectedElements = [];

    let lastValue = value[value.length - 1];
    let restValue = value.slice(0, value.length - 1);
    if (lastValue) {
      if (lastValue.value === "all") {
        if (restValue.find((v) => v.value === "all") === undefined) {
          selectedValue = [{ value: "all", label: languages.schedule.all }];
          selectedElements = this.props.teams.sort((a, b) => {
            if (a.division > b.division) {
              return 1;
            } else if (a.division < b.division) {
              return -1;
            } else {
              function chunkify(t) {
                var tz = [],
                  x = 0,
                  y = -1,
                  n = 0,
                  i,
                  j;

                while ((i = (j = t.charAt(x++)).charCodeAt(0))) {
                  // eslint-disable-next-line
                  var m = i == 46 || (i >= 48 && i <= 57);
                  if (m !== n) {
                    tz[++y] = "";
                    n = m;
                  }
                  tz[y] += j;
                }
                return tz;
              }

              let toChunkA = a["name"] || "";
              let toChunkB = b["name"] || "";

              var aa = chunkify(toChunkA.toString().toLowerCase());
              var bb = chunkify(toChunkB.toString().toLowerCase());

              for (let x = 0; aa[x] && bb[x]; x++) {
                if (aa[x] !== bb[x]) {
                  var c = Number(aa[x]),
                    d = Number(bb[x]);
                  // eslint-disable-next-line
                  if (c == aa[x] && d == bb[x]) {
                    return c - d;
                  } else return aa[x] > bb[x] ? 1 : -1;
                }
              }
              return aa.length - bb.length;
            }
          });
        }
      } else {
        selectedValue = value;
        selectedElements = value;
        if (restValue.find((v) => v.value === "all") !== undefined) {
          selectedElements.shift();
        }
      }
    }
    this.setState({
      selectedTeams: selectedElements,
      selectedTeamsValue: selectedValue,
    });
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  UNSAFE_componentWillMount = (nextProps) => {
    if (this.props.break) {
      this.updateState(this.props.break);
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const tournamentBreak = nextProps.break;
    if (tournamentBreak) {
      this.updateState(tournamentBreak);
    }
  };

  updateState = (tournamentBreak) => {
    this.setState({
      name: tournamentBreak.name || "",
      duration: tournamentBreak.duration || 20,
      selectedTeams: this.props.eventOptions.filter(
        (o) =>
          (tournamentBreak.teams || [])
            .filter((t) => this.props.teamsByKey[t] !== undefined)
            .find((t) => t === o.value) !== undefined
      ),
      selectedTeamsValue: this.props.eventOptions.filter(
        (o) =>
          (tournamentBreak.teams || [])
            .filter((t) => this.props.teamsByKey[t] !== undefined)
            .find((t) => t === o.value) !== undefined
      ),
    });
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  };

  handleAdd = (e) => {
    e.preventDefault();
    this.toggleDialog();
    const db = window.firebase.firestore();
    let batch = db.batch();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    let newBreaks = this.props.tournament.breaks || {};
    const newBreakKeys = Object.keys(newBreaks).sort((a, b) => a - b);
    const newKey = Number(newBreakKeys[newBreakKeys.length - 1]) + 1 || 0;
    newBreaks[newKey] = {
      name: this.state.name,
      duration: this.state.duration || 20,
      teams: (this.state.selectedTeams || []).map((t) => t.value),
      field: this.props.field.id,
      day: this.props.day,
      numInField:
        this.props.matches.length > 0
          ? Number(
              this.props.matches[this.props.matches.length - 1].numInField
            ) + 1
          : 0,
      isEvent: this.props.isEvent ? true : false,
    };
    batch.update(tournamentRef, { breaks: newBreaks });
    if (this.props.isEvent) {
      batch.set(db.collection("cacheUpdates").doc(), {
        tournamentId: this.props.tournament[".key"],
        fieldId: this.props.field.id,
        dayId: this.props.day,
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
      if (this.props.tournament.ia) {
        batch.set(db.collection("cacheUpdatesApp").doc(), {
          tournamentId: this.props.tournament[".key"],
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
      }
    }
    batch.commit().then(() => {
      this.setState({ selectedTeams: [], selectedTeamsValue: [] });
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.toggleDialog();
    const db = window.firebase.firestore();
    let batch = db.batch();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let newBreak = this.props.break;

    newBreak["name"] = this.state.name;
    newBreak["duration"] = this.state.duration || 20;
    newBreak["teams"] = (this.state.selectedTeams || []).map((t) => t.value);

    const breakId = this.props.break.id;
    let newBreaks = this.props.tournament.breaks || {};
    newBreaks[breakId] = newBreak;

    batch.update(tournamentRef, { breaks: newBreaks });
    batch.set(db.collection("cacheUpdates").doc(), {
      tournamentId: this.props.tournament[".key"],
      fieldId: this.props.break.field,
      dayId: this.props.break.day,
      status: "pending",
      timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
    });
    if (this.props.tournament.ia) {
      batch.set(db.collection("cacheUpdatesApp").doc(), {
        tournamentId: this.props.tournament[".key"],
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
    }
    batch.commit();
  };

  handleDelete = (e) => {
    e.preventDefault();
    this.toggleDialog();
    const db = window.firebase.firestore();
    let batch = db.batch();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    let newBreaks = this.props.tournament.breaks || {};
    delete newBreaks[this.props.break.id];
    let field = this.props.break.field;
    let day = this.props.break.day;
    batch.update(tournamentRef, { breaks: newBreaks });
    batch.set(db.collection("cacheUpdates").doc(), {
      tournamentId: this.props.tournament[".key"],
      fieldId: field,
      dayId: day,
      status: "pending",
      timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
    });
    if (this.props.tournament.ia) {
      batch.set(db.collection("cacheUpdatesApp").doc(), {
        tournamentId: this.props.tournament[".key"],
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
    }
    batch.commit();
  };

  render() {
    return (
      <div>
        {this.props.break ? (
          <IconButton
            aria-label="Change"
            onClick={
              this.props.tournament.scheduleLocked || false
                ? () => {}
                : this.toggleDialog
            }
            style={{
              height: 20,
              width: 20,
              marginTop: 8,
              color: "gray",
            }}
          >
            {this.props.tournament.scheduleLocked || false ? (
              <LockIcon
                style={{ height: 20, width: 20, position: "absolute", top: 2 }}
              />
            ) : (
              <CreateIcon
                style={{ height: 20, width: 20, position: "absolute", top: 2 }}
              />
            )}
          </IconButton>
        ) : (
          <Button
            variant="text"
            onClick={this.toggleDialog}
            size="small"
            fullWidth
            disabled={this.props.tournament.scheduleLocked || false}
          >
            <AddIcon style={{ height: 16, width: 16 }} />
            {this.props.isEvent
              ? languages.schedule.event
              : languages.schedule.break}
          </Button>
        )}
        <EditBreakDialog
          name={this.state.name}
          duration={this.state.duration}
          open={this.state.open}
          break={this.props.break}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleSubmit={this.props.break ? this.handleSubmit : this.handleAdd}
          handleDelete={this.handleDelete}
          isEvent={this.props.isEvent}
          options={this.props.eventOptions}
          selectedValue={this.state.selectedTeamsValue}
          handleSelectChange={this.handleSelectChange}
        />
      </div>
    );
  }
}

export default EditBreakContainer;
